import firebase from "firebase";

export class DigitalSignagePage {
  contentCreatorId: string;
  displayDate: boolean;
  displayForDays: string[];
  displayOn: string;
  enabled: boolean;
  hasExpirationDate: boolean;
  name: string;
  order: number;
  time: Time | null;
  timeInSeconds: number | null;
  type: string;
  url: string;
  title: string;
  expirationDate?: Date | null | firebase.firestore.Timestamp;
  startDate: Date | null | firebase.firestore.Timestamp;

  constructor() {
    this.contentCreatorId = "";
    this.displayDate = false;
    this.displayForDays = [];
    this.displayOn = "";
    this.enabled = true;
    this.hasExpirationDate = false;
    this.name = "";
    this.order = 0;
    this.time = null;
    this.timeInSeconds = null;
    this.type = "";
    this.url = "";
    this.title = "";
    this.startDate = null;
  }
}

export class DigitalSignagePageBuilder {
  page: DigitalSignagePage;
  constructor() {
    this.page = new DigitalSignagePage();
  }
  setContentCreatorId(value) {
    this.page.contentCreatorId = value;
    return this;
  }
  setEnabled(value) {
    this.page.enabled = value;
    return this;
  }
  setName(value) {
    this.page.name = value;
    return this;
  }
  setOrder(value) {
    this.page.order = value;
    return this;
  }
  setTimeInSeconds(value) {
    this.page.timeInSeconds = value;
    return this;
  }
  setTitle(value) {
    this.page.title = value;
    return this;
  }
  setType(value) {
    this.page.type = value;
    return this;
  }
  setUrl(value) {
    this.page.url = value;
    return this;
  }
  setHasExpirationDate(value) {
    this.page.hasExpirationDate = value;
    return this;
  }
  setDisplayDate(value) {
    this.page.displayDate = value;
    return this;
  }
  setDisplayOn(value) {
    this.page.displayOn = value;
    return this;
  }
  setDisplayForDays(value) {
    this.page.displayForDays = value;
    return this;
  }
  setStartDate(value) {
    this.page.startDate = value;
    return this;
  }
  setTime(value) {
    this.page.time = value;
    return this;
  }
  build() {
    return this.page;
  }
}

class Time {
  start: string;
  end: string;
}